import { useToastState, dismissToast, type Toast } from './use-toast';
import { X } from 'lucide-react';

export function Toaster() {
  const toasts = useToastState();

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-md"
      role="region"
      aria-label="Notifications"
    >
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={() => dismissToast(toast.id)} />
      ))}
    </div>
  );
}

interface ToastItemProps {
  toast: Toast;
  onDismiss: () => void;
}

function ToastItem({ toast, onDismiss }: ToastItemProps) {
  const isDestructive = toast.variant === 'destructive';

  return (
    <div
      className={`
        rounded-lg border p-4 shadow-lg animate-in slide-in-from-right-full
        ${isDestructive ? 'bg-destructive text-destructive-foreground border-destructive' : 'bg-background text-foreground border-border'}
      `}
      role="alert"
      data-testid="toast"
    >
      <div className="flex items-start gap-3">
        <div className="flex-1">
          {toast.title && (
            <p className="font-semibold text-sm" data-testid="toast-title">
              {toast.title}
            </p>
          )}
          {toast.description && (
            <p className="text-sm mt-1 opacity-90" data-testid="toast-description">
              {toast.description}
            </p>
          )}
        </div>
        <button
          onClick={onDismiss}
          className="shrink-0 rounded-md p-1 opacity-70 hover:opacity-100 transition-opacity"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
